<template>
  <div id="layout">
      <div style="width: 100%;height: 83px; background-color:#0D2EA0;margin-top:0px;padding-top:0px;">
  
      <!-- <el-image
            :src="require('@/assets/images/brotherlogo.png')"
            fit="fill"></el-image> -->
      </div>
      <router-view />
      
      <div align="center" id="footer">
          <footer style="padding-top:10px; line-height: 14px; font-size:12px;">
              <!-- 备案号：<el-link style="font-size:12px;" type="info" title="备案号" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备17049746号</el-link><br />
              兄弟高科技（深圳）有限公司<br />
              &copy; Brother Technology(Shenzhen),Ltd. All Rights Reserved. -->
          </footer>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Layout',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="scss"></style>

  
  <style>
  #layout {
    width: 100%;
    height: 100%;
  }
  
  #footer {
     width:100%;
     height:65px;   /* 底部高度 */
     background-color:#F7FBFD;
  }
  </style>
  
  